import styled from "styled-components";
import { Link } from "react-router-dom";

export const IrelandSectionWrap = styled.section`
  padding: 3rem 0 5rem;
  position: relative;
  z-index: 1;
`;

export const MapRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  margin-bottom: 3rem;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const MapVisual = styled.div`
  display: flex;
  justify-content: center;
`;

export const MapInner = styled.div`
  position: relative;
  width: 100%;
  max-width: 360px;
  aspect-ratio: 605 / 775;
`;

export const IrelandMapImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  object-position: center;
`;

export const MapPinsLayer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;

/** Vector pins — uniform scale (meet) keeps circles round on the tall map. */
export const MapPinsSvg = styled.svg`
  width: 100%;
  height: 100%;
  display: block;
  overflow: visible;

  circle {
    shape-rendering: geometricPrecision;
  }
`;

export const MapHeading = styled.h2`
  font-family: "SatoshiBold", sans-serif;
  font-size: clamp(1.5rem, 2.5vw, 2rem);
  line-height: 1.25;
  color: ${(props) => props.theme.colors.balck_200};
  font-weight: 700;
`;

export const ImpactCard = styled.div`
  position: relative;
  z-index: 2;
  overflow: hidden;
  border-radius: 20px;
  padding: 2.5rem 2rem;
  background: linear-gradient(
    135deg,
    rgba(74, 147, 207, 0.12) 0%,
    rgba(255, 255, 255, 1) 60%
  );
  border: 1px solid #e8f0f8;
  box-shadow: 0 16px 48px rgba(74, 147, 207, 0.1);
`;

export const ImpactCardBody = styled.div`
  position: relative;
  z-index: 2;

  .eyebrow {
    font-family: "SatoshiRegular", sans-serif;
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 0.5rem;
  }

  .stat {
    font-family: "SatoshiBold", sans-serif;
    font-size: clamp(2.5rem, 5vw, 3.5rem);
    font-weight: 700;
    color: ${(props) => props.theme.colors.balck_200};
    margin-bottom: 0.35rem;
  }

  .subtext {
    font-family: "SatoshiRegular", sans-serif;
    font-size: 1rem;
    color: #555;
    margin-bottom: 1.5rem;
  }
`;

export const DemoButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  cursor: pointer;
  font-family: "SatoshiBold", sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  padding: 0.75rem 1.4rem;
  border-radius: 50px;
  background: ${(props) => props.theme.colors.balck_200};
  color: ${(props) => props.theme.colors.white_100};
  transition: box-shadow 0.25s ease, transform 0.25s ease;
  position: relative;
  z-index: 3;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
    color: ${(props) => props.theme.colors.white_100};
  }
`;

export const ChartDeco = styled.div`
  position: absolute;
  right: 2rem;
  bottom: 1rem;
  display: flex;
  align-items: flex-end;
  gap: 6px;
  opacity: 0.15;
  pointer-events: none;
  z-index: 0;

  span {
    display: block;
    width: 8px;
    background: ${(props) => props.theme.colors.purple_100};
    border-radius: 4px 4px 0 0;
  }
`;
